<form nz-form (ngSubmit)="checkValidation()" [formGroup]="formGroup" [nzLayout]="'vertical'">
    <!-- Basic Information -->

    <div nz-row nzJustify="start" nzAlign="middle" [nzGutter]="16">
        <!-- Theme -->
        <div nz-col nzSpan="8">
            <nz-form-item>
                <nz-form-label nzFor="mode">Mode</nz-form-label>
                <nz-form-control>
                    <nz-select [formControl]="formGroup.get('mode')" nzShowSearch>
                        <nz-option *ngFor="let mode of StreamEventModeSelections" [nzValue]="mode" [nzLabel]="mode">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <ng-container *ngIf="isEditMode">
            <div nz-col nzSpan="8">
                <button type="button" nz-button nzType="primary" style="width: 100%;" (click)="setModeNow()"
                    [disabled]="orgData?.mode === formGroup.get('mode').value">
                    Set To {{formGroup.get('mode').value}} Mode Now
                </button>
            </div>


            <div nz-col nzSpan="8">
                <button type="button" nz-button nzType="primary" style="width: 100%;" (click)="playNow()"
                    [disabled]="orgData?.type === 'RealtimeLiveStream'">
                    Play Stream Event Now
                </button>
            </div>
        </ng-container>

    </div>

    <div nz-row [nzGutter]="16">
        <div nz-col nzSpan="8">
            <nz-form-item>
                <nz-form-label nzFor="status" nzRequired>status</nz-form-label>
                <nz-form-control nzErrorTip="status is required">
                    <nz-select [formControl]="formGroup.get('status')" nzShowSearch>
                        <nz-option *ngFor="let status of eventStatusOptions" [nzValue]="status" [nzLabel]="status">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
            <nz-form-item>
                <nz-form-label nzFor="type" nzRequired>type</nz-form-label>
                <nz-form-control nzErrorTip="type is required">
                    <nz-select [formControl]="formGroup.get('type')" nzShowSearch>
                        <nz-option *ngFor="let type of typeOptions" [nzValue]="type" [nzLabel]="type">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
            <nz-form-item>
                <nz-form-label nzFor="theme" nzRequired>Theme</nz-form-label>
                <nz-form-control nzErrorTip="Theme is required">
                    <input nz-input type="text" [formControl]="formGroup.get('theme')">
                </nz-form-control>
            </nz-form-item>
        </div>

        <!-- Asset -->
        <div nz-col nzSpan="8">
            <nz-form-item>
                <nz-form-label nzFor="assetId" nzRequired>Asset</nz-form-label>
                <nz-form-control nzErrorTip="Asset is required">
                    <nz-select [formControl]="formGroup.get('assetId')" nzShowSearch>
                        <nz-option *ngFor="let asset of assetOptions" [nzValue]="asset.id"
                            [nzLabel]="asset.name || asset.id">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>

    <!-- Description -->
    <div nz-row [nzGutter]="16">
        <div nz-col nzSpan="24">
            <nz-form-item>
                <nz-form-label nzFor="description" nzRequired>Description</nz-form-label>
                <nz-form-control nzErrorTip="Description is required">
                    <textarea nz-input [formControl]="formGroup.get('description')"
                        [nzAutosize]="{minRows: 3}"></textarea>
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>

    <!-- Start Time and Streamer -->
    <div nz-row [nzGutter]="16">
        <!-- Start At -->
        <div nz-col nzSpan="12">
            <nz-form-item>
                <nz-form-label nzFor="startedAt" nzRequired>Start At (UTC)</nz-form-label>
                <nz-form-control nzErrorTip="Start time is required">
                    <app-date-picker [formCtrl]="formGroup.get('startedAt')" [showSeconds]="true"></app-date-picker>
                </nz-form-control>
            </nz-form-item>
        </div>

        <!-- Streamer -->
        <div nz-col nzSpan="12">
            <nz-form-item>
                <nz-form-label nzFor="streamerId" nzRequired>Streamer</nz-form-label>
                <nz-form-control nzErrorTip="Streamer is required">
                    <nz-select [formControl]="formGroup.get('streamerId')" nzShowSearch>
                        <nz-option *ngFor="let streamer of streamerOptions" [nzValue]="streamer.id"
                            [nzLabel]="streamer.name || streamer.id">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>

    <!-- Stage IDs and Cover URL -->
    <div nz-row [nzGutter]="16">
        <!-- Stage IDs -->
        <div nz-col nzSpan="12">
            <nz-form-item>
                <nz-form-label nzFor="stageIds">Stage IDs</nz-form-label>
                <nz-form-control>
                    <nz-select [formControl]="formGroup.get('stageIds')" nzMode="multiple" nzShowSearch nzAllowClear>
                        <nz-option *ngFor="let stage of stageOptions" [nzValue]="stage.id"
                            [nzLabel]="stage.name || stage.id">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>

        <!-- Cover URL -->
        <div nz-col nzSpan="12">
            <nz-form-item>
                <nz-form-label nzFor="coverUrl" nzRequired>Cover Image</nz-form-label>
                <nz-form-control nzErrorTip="Cover image is required">
                    <app-mit-uploader [formCtrl]="formGroup.get('coverUrl')"
                        [accept]="'image/png, image/jpeg'"></app-mit-uploader>
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>
    <ng-container *ngIf="isEditMode || formGroup.get('type').value === 'SimulateLiveStream'">
        <!-- Channel Information -->
        <nz-divider nzText="Channel Information" nzOrientation="left"></nz-divider>

        <!-- Channel Status and Record Status -->
        <div nz-row [nzGutter]="16">
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzFor="channelStatus">Channel Status</nz-form-label>
                    <nz-form-control>
                        <nz-select [formControl]="formGroup.get('channel.status')">
                            <nz-option *ngFor="let status of channelStatusOptions" [nzValue]="status"
                                [nzLabel]="status">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzFor="recordStatus">Record Status</nz-form-label>
                    <nz-form-control>
                        <nz-select [formControl]="formGroup.get('channel.recordStatus')">
                            <nz-option *ngFor="let record of recordStatusOptions" [nzValue]="record" [nzLabel]="record">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzFor="recordFileVersion">Record File Version</nz-form-label>
                    <nz-form-control>
                        <nz-select [formControl]="formGroup.get('channel.recordFileVersion')">
                            <nz-option *ngFor="let stream of streamChannelRecordFileVersionSelections"
                                [nzValue]="stream" [nzLabel]="stream">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <!-- <div nz-col nzSpan="8">
            <nz-form-item>
                <nz-form-label nzFor="broadcasterStatus">Broadcaster Status</nz-form-label>
                <nz-form-control>
                    <nz-select [formControl]="formGroup.get('channel.broadcasterStatus')">
                        <nz-option *ngFor="let stream of streamChannelBroadcasterStatusSelections" [nzValue]="stream"
                            [nzLabel]="stream">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div> -->
        </div>

        <!-- Duration and Times -->
        <div nz-row [nzGutter]="16">
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzFor="channelStartedAt">Channel Start At</nz-form-label>
                    <nz-form-control>
                        <app-date-picker [formCtrl]="formGroup.get('channel.startedAt')"
                            [showSeconds]="true"></app-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzFor="duration">Duration(seconds)</nz-form-label>
                    <nz-form-control>
                        <nz-input-number [formControl]="formGroup.get('channel.duration')" class="mit-number-field"
                            [nzMin]="0" (nzBlur)="validateInteger()"></nz-input-number>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12" class="calculate-btn">
                <button type="button" nz-button nzType="default" style="width: 100%;" (click)="calculateFinishTime()"
                    [disabled]="!formGroup.get('channel.startedAt')?.value">
                    Calculate Finish Time By Start Time & Duration
                </button>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzFor="channelFinishedAt">Channel Finished At</nz-form-label>
                    <nz-form-control>
                        <app-date-picker [formCtrl]="formGroup.get('channel.finishedAt')"
                            [showSeconds]="true"></app-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <!-- Record Files -->
        <nz-divider nzText="Record Files" nzOrientation="left"></nz-divider>
        <div>
            <div *ngFor="let file of recordFiles.controls; let i = index">
                <div nz-row [nzGutter]="16">
                    <div nz-col nzSpan="6">
                        <nz-form-item>
                            <nz-form-label>Partial Key</nz-form-label>
                            <nz-form-control>
                                <input nz-input [formControl]="file.get('partialKey')" placeholder="Partial Key">
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzSpan="14">
                        <nz-form-item>
                            <nz-form-label nzFor="coverUrl" nzRequired>File URL</nz-form-label>
                            <nz-form-control>
                                <app-mit-uploader [formCtrl]="file.get('fileUrl')"></app-mit-uploader>
                            </nz-form-control>
                        </nz-form-item>
                    </div>




                    <div nz-col nzSpan="4">
                        <nz-form-item>
                            <nz-form-label>&nbsp;</nz-form-label>
                            <nz-form-control>
                                <button nz-button nzType="default" nzDanger (click)="removeRecordFile(i)">
                                    Remove
                                </button>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
            </div>
            <button nz-button type="button" nzType="dashed" (click)="addRecordFile()"
                style="width: 100%; margin-bottom: 16px;">
                Add Record File
            </button>
        </div>
    </ng-container>


    <!-- Buttons -->
    <div style="text-align: center; margin-top: 20px;">
        <button type="button" nz-button nzType="default" (click)="cancel()" style="margin-right: 10px;">
            Cancel
        </button>
        <button type="submit" nz-button nzType="primary">
            Save
        </button>
    </div>
</form>